/**
 * Unified multi-script font stack for the whole platform.
 *
 * The browser resolves the font per-character, so Latin and Arabic text render
 * with Readex Pro (a bilingual Latin/Arabic typeface, so both scripts get its
 * unified look) while each other non-Latin script falls back to the matching
 * Noto Sans face - Readex Pro has no glyphs for those, so the browser skips it
 * automatically. All of these are loaded as web fonts in `index.html`, so
 * typography looks identical and professional across every OS and language
 * (incl. Arabic, Urdu, Hindi, Bengali, Sinhala, Nepali) instead of relying on
 * inconsistent system fonts.
 */
export const APP_FONT_FAMILY = [
  '"Readex Pro"',
  '"Noto Sans Arabic"',
  '"Noto Sans Devanagari"',
  '"Noto Sans Bengali"',
  '"Noto Sans Sinhala"',
  '"Helvetica"',
  '"Arial"',
  'sans-serif',
].join(', ');
